module.exports = __webpack_public_path__ + "img/icon_server_blue.90e5d004.png";